module.exports = {
    footerText: 'Copyright iTribe © 2021',
}
